'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, } from 'react';
import { useOutsideClick } from '../../lib/hooks/useOutsideClick';
import { Button as LMFButton } from '../Button';
import * as Styles from './styles';
import { usePopoverPosition } from './usePopoverPosition';
export const PopoverContext = createContext({
    active: false,
    setActive: () => { },
    setButtonRef: () => { },
    setWrapperRef: () => { },
    setPanelRef: () => { },
    position: { top: 0, left: 0 },
});
export function Wrapper({ children }) {
    const [active, setActive] = useState(false);
    const { position, buttonRef, panelRef, setButtonRef, setWrapperRef, setPanelRef } = usePopoverPosition();
    useOutsideClick([buttonRef, panelRef], () => {
        setActive(false);
    });
    const ctx = {
        active,
        setActive,
        setButtonRef,
        setWrapperRef,
        setPanelRef,
        position,
    };
    return (_jsx(PopoverContext.Provider, { value: ctx, children: _jsx(Styles.Wrapper, { ref: setWrapperRef, children: typeof children === 'function' ? children(ctx) : children }) }));
}
export function Button({ component: Component, children }) {
    const { setButtonRef, active, setActive } = useContext(PopoverContext);
    const ComponentToRender = Component ?? LMFButton;
    return (_jsx(ComponentToRender, { ref: setButtonRef, onClick: () => setActive(a => !a), active: active, "aria-expanded": active, "aria-haspopup": true, children: children }));
}
export function Panel({ children, className, role = 'dialog', ...rest }) {
    const { active, position, setPanelRef } = useContext(PopoverContext);
    if (!active)
        return null;
    return (_jsx(Styles.Panel, { ref: setPanelRef, className: className, active: active, top: position.top, left: position.left, role: role, ...rest, children: children }));
}
//# sourceMappingURL=Popover.js.map